<script>
  import { setQueryReferrer } from '../stores/referrer';
  setQueryReferrer();
</script>
